<div>
  <input type="checkbox"
          (click)="completeItem()"
          [checked]="item.completed"/>

  <span class="todo-title" [ngClass]="{'todo-complete': item.completed}">
        {{ item.title }}</span>

  <span (click)="removeItem()" class="material-icons-outlined" alt="delete">delete_forever</span>
  <!-- <span (click)="updateItem()" style="padding-right: 10px;" class="material-icons-outlined" alt="edit">edit</span> -->

</div>
